import { useEffect, useState } from "react";

export function useTimer(timer = 1000) {
	const [count, setCount] = useState(0);

	useEffect(() => {
		const id = setTimeout(() => setCount(s => s + 1), timer);
		return () => clearTimeout(id);
	}, [count]);

	return count;
}